<template>
  <h1>404，未找到该路径</h1>
</template>
<script>
export default {
  name: '404',
}
</script>
